module.exports = __webpack_public_path__ + "assets/pdf/Jeffectリーフレット.7513da02.pdf";